import Loading from '@cartwhl/ui/atoms/Loading';

export default function DefaultAppletLoading() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">
      <Loading className="text-gray-45 h-10 w-10" />
    </div>
  );
}
